<template>
  <el-container class="layout-shell">
    <el-aside :width="isCollapse ? '76px' : '248px'" class="sidebar">
      <div class="brand-box" :class="{ collapsed: isCollapse }">
        <img src="@/assets/img/index/adminpro.png" alt="logo" />
        <div v-if="!isCollapse" class="brand-text">
          <strong>广告管理系统</strong>
          <span>管理员控制台</span>
        </div>
      </div>

      <el-scrollbar class="menu-scroll">
        <el-menu
          :default-active="activePath"
          :default-openeds="defaultOpeneds"
          :collapse="isCollapse"
          :collapse-transition="false"
          unique-opened
          router
          class="layout-menu"
        >
          <menu-node
            v-for="item in visibleMenuTree"
            :key="item.id"
            :node="item"
            :collapse="isCollapse"
          />
        </el-menu>
      </el-scrollbar>
    </el-aside>

    <el-container class="main-shell">
      <el-header class="layout-header">
        <div class="header-left">
          <button class="collapse-btn" @click="isCollapse = !isCollapse">
            <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </button>
          <div class="header-title">
            <h3>{{ headerTitle }}</h3>
            <span>{{ currentDateText }}</span>
          </div>
        </div>

        <div class="header-right">
          <div class="user-card">
            <div class="user-avatar">{{ nicknameText.slice(0, 1) || "A" }}</div>
            <div class="user-meta">
              <strong>{{ greetingText }}，{{ nicknameText }}</strong>
              <span>{{ roleText }}</span>
            </div>
          </div>
          <el-button size="mini" plain @click="logout">退出登录</el-button>
        </div>
      </el-header>

      <el-main class="layout-main">
        <router-view class="route-view"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { findMenuByPath } from "@/utils/menu";

const MenuNode = {
  name: "MenuNode",
  props: {
    node: {
      type: Object,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
  },
  render(h) {
    const node = this.node;
    const visibleChildren = (node.children || []).filter(
      (item) => item.type !== "action" && Number(item.is_visible) === 1
    );

    if (node.type === "menu" && node.path) {
      return h(
        "el-menu-item",
        {
          props: {
            index: node.path,
          },
        },
        [
          h("i", {
            class: node.icon || "el-icon-menu",
          }),
          h("span", { slot: "title" }, node.title),
        ]
      );
    }

    if (!visibleChildren.length) {
      return null;
    }

    return h(
      "el-submenu",
      {
        props: {
          index: String(node.id),
        },
      },
      [
        h(
          "template",
          { slot: "title" },
          [
            h("i", {
              class: node.icon || "el-icon-folder-opened",
            }),
            h("span", node.title),
          ]
        ),
        ...visibleChildren.map((child) =>
          h("menu-node", {
            key: child.id,
            props: {
              node: child,
              collapse: this.collapse,
            },
          })
        ),
      ]
    );
  },
};

export default {
  components: {
    MenuNode,
  },
  data() {
    return {
      isCollapse: false,
    };
  },
  computed: {
    visibleMenuTree() {
      return (this.$store.state.menuTree || []).filter(
        (item) => item.type !== "action" && Number(item.is_visible) === 1
      );
    },
    activePath() {
      return this.$route.path;
    },
    defaultOpeneds() {
      const menu = findMenuByPath(this.$store.state.menuTree, this.$route.path);
      if (!menu || !Array.isArray(menu.idChain)) {
        return [];
      }

      return menu.idChain.slice(0, -1);
    },
    nicknameText() {
      return this.$store.state.adminInfo.nickname || "管理员";
    },
    roleText() {
      return Number(this.$store.state.adminInfo.rating) === 1
        ? "超级管理员"
        : "普通管理员";
    },
    greetingText() {
      const hour = new Date().getHours();
      if (hour < 6) return "凌晨好";
      if (hour < 12) return "上午好";
      if (hour < 14) return "中午好";
      if (hour < 18) return "下午好";
      return "晚上好";
    },
    headerTitle() {
      return this.$store.state.navText || "后台首页";
    },
    currentDateText() {
      return new Date().toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutWithConfirm");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.$store.dispatch("syncCurrentRouteMeta", route.path);
      },
    },
  },
  created() {
    this.$store.dispatch("getMenuList");
    this.$store.dispatch("getAppList");
    this.$store.dispatch("getBaseUrl");
  },
};
</script>

<style lang="less" scoped>
.layout-shell {
  height: 100vh;
  background: #eef3f9;
}

.sidebar {
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e3ebf6;
  background:
    linear-gradient(180deg, #f8fbff 0%, #f1f6fd 100%);
  box-shadow: inset -1px 0 0 rgba(15, 72, 156, 0.03);
}

.brand-box {
  height: 78px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-bottom: 1px solid rgba(47, 115, 235, 0.08);

  &.collapsed {
    padding: 0 10px;
    justify-content: center;
  }

  img {
    width: 44px;
    height: 44px;
    object-fit: contain;
  }
}

.brand-text {
  display: flex;
  flex-direction: column;

  strong {
    color: #24467f;
    font-size: 18px;
    line-height: 1.1;
  }

  span {
    margin-top: 4px;
    color: #7b93ba;
    font-size: 12px;
  }
}

.menu-scroll {
  flex: 1;
}

.layout-menu {
  border-right: none;
  background: transparent;
}

.main-shell {
  min-width: 0;
  height: 100vh;
  overflow: hidden;
}

.layout-header {
  height: 76px !important;
  margin: 14px 14px 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 22px;
  background:
    linear-gradient(135deg, #1e55bb 0%, #2f7dec 100%);
  box-shadow: 0 12px 24px rgba(31, 89, 191, 0.18);
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
}

.collapse-btn {
  width: 42px;
  height: 42px;
  margin-right: 16px;
  border: none;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  i {
    font-size: 18px;
  }
}

.header-title {
  color: #fff;

  h3 {
    margin: 0 0 4px;
    font-size: 20px;
    font-weight: 600;
  }

  span {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
  }
}

.user-card {
  margin-right: 12px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.12);
}

.user-avatar {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-weight: 700;
}

.user-meta {
  display: flex;
  flex-direction: column;
  color: #fff;

  strong {
    font-size: 13px;
    font-weight: 600;
  }

  span {
    margin-top: 3px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
  }
}

.layout-main {
  padding: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.route-view {
  flex: 1;
  min-height: 0;
  padding: 14px;
  border-radius: 24px;
  background: #f9fbff;
  box-shadow: inset 0 0 0 1px rgba(47, 115, 235, 0.05);
  overflow: auto;
}

/deep/ .el-menu-item,
/deep/ .el-submenu__title {
  height: 48px;
  line-height: 48px;
  margin: 6px 12px;
  border-radius: 14px;
  color: #5f76a2;

  i {
    color: #7e97c5;
  }
}

/deep/ .el-menu-item.is-active {
  color: #1b56b7;
  background: linear-gradient(135deg, rgba(47, 115, 235, 0.12), rgba(47, 115, 235, 0.04));
  box-shadow: inset 0 0 0 1px rgba(47, 115, 235, 0.1);

  i {
    color: #1b56b7;
  }
}

/deep/ .el-menu-item:hover,
/deep/ .el-submenu__title:hover {
  background: rgba(47, 115, 235, 0.06);
  color: #1f5bbb;
}
</style>
